// index.js
import "./suppressErrors";
import React from "react";
import { createRoot } from "react-dom/client";
import reportWebVitals from "./reportWebVitals";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";

import { PersistGate } from "redux-persist/integration/react";
import { Provider } from "react-redux";
import { store, persistor } from "./store";
import App from "./App";
import theme from "./theme/theme";
import { ThemeProvider } from "@mui/material";
import { SnackbarProvider } from "notistack";

const root = createRoot(document.getElementById("root"));

const app = (
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <ThemeProvider theme={theme}>
        <SnackbarProvider
          maxSnack={3}
          anchorOrigin={{
            vertical: "top",
            horizontal: "center",
          }}
          autoHideDuration={4000}
          preventDuplicate={true}
        >
          <App />
        </SnackbarProvider>
      </ThemeProvider>
    </PersistGate>
  </Provider>
);

root.render(app);
